import React, { useState } from 'react';
import { Col, Row, Modal, Label } from "reactstrap";
import { VesselMachineryList } from '../../VesselConfiguration.model';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../';
import GeneralSettingsRow from './GeneralSettingsRow';
import { fetchMachinaryOptions, updateMachineGenralSettings } from '../../../vesselMaster.hooks';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { successToast, errorToast } from '../../../../Components/Toasts';

const GeneralSettings = () => {
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [machineryRow, setMachineryRow] = useState<any>();
    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const queryClient = useQueryClient();
    const { data, isLoading } = useQuery(["Vessel-gernal-setting", VesselID], async () => { return await fetchMachinaryOptions(VesselID); }, {
        staleTime: 10000
    })
    const { mutate } = useMutation(updateMachineGenralSettings, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('myDataQueryKey');
            successToast('Data updated!');
            setmodal_backdrop(false);
        },
        onError: (error: any) => {
            errorToast('Update failed:' + error.messages ?? "Unkonw Reason");
        }
    })

    const GeneralSettingsSubmit = () => {
        mutate(machineryRow);
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    const handleGeneralSettingsRow = (machine: VesselMachineryList) => {
        setMachineryRow(machine);
    }
    if (isLoading) return <div>Loading</div>;
    return (
        <>
            <Row>
                <Col>
                    <div className="table-responsive mb-5">
                        <table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Vessel machinery name</th>
                                    <th>Machinery</th>
                                    <th>Runnning hours</th>
                                    <th>Energy parameter</th>
                                    <th>SFOC</th>
                                    <th>EGCS</th>
                                    <th>SCR/EGR</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data && data.length > 0 ?
                                        data.map((vesselMachinery: any, index: number) => {
                                            return (
                                                <tr key={vesselMachinery.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{vesselMachinery.vessel_machinery_name}</td>
                                                    <td>{vesselMachinery.machinery}</td>
                                                    <td>
                                                        {vesselMachinery.running_hour === true ? <i className=' bx bx-check-circle icon_s18'></i> : null}
                                                    </td>
                                                    <td>
                                                        {vesselMachinery.energy_parameter === true ? <i className=' bx bx-check-circle icon_s18'></i> : null}
                                                    </td>
                                                    <td>
                                                        {vesselMachinery.sfoc_required === true ? <i className=' bx bx-check-circle icon_s18'></i> : null}
                                                    </td>
                                                    <td>
                                                        {vesselMachinery.is_egcs === true ? <i className=' bx bx-check-circle icon_s18'></i> : null}
                                                    </td>
                                                    <td>
                                                        {vesselMachinery.is_scr_or_egr === true ? <i className=' bx bx-check-circle icon_s18'></i> : null}
                                                    </td>

                                                    <td>
                                                        <i className='dripicons-document-edit' onClick={() => {
                                                            tog_backdrop();
                                                            handleGeneralSettingsRow(vesselMachinery)
                                                        }} >
                                                        </i></td>
                                                </tr>
                                            )
                                        })
                                        : <tr><td colSpan={9}><Label>Please add machinery to this vessel</Label></td></tr>
                                }
                            </tbody>
                        </table>
                        <Modal
                            isOpen={modal_backdrop}
                            toggle={() => {
                                tog_backdrop();
                            }}
                            backdrop={"static"}
                            id="staticBackdrop"
                            size='xl'
                        >
                            <div className="modal-header">
                                <h5 className="modal-title" id="staticBackdropLabel">
                                    Edit
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setmodal_backdrop(false);
                                    }}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive mb-5">
                                    <table className="table">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Vessel machinery name</th>
                                                <th>Machinery</th>
                                                <th>Runnning hours</th>
                                                <th>Energy parameter</th>
                                                <th>SFOC</th>
                                                <th>EGCS</th>
                                                <th>SCR/EGR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <GeneralSettingsRow vesselMachinery={machineryRow} />
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() => {
                                        setmodal_backdrop(false);
                                    }}
                                >
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary btn_Margin" onClick={(e: any) => GeneralSettingsSubmit()}>
                                    Save
                                </button>
                            </div>
                        </Modal>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default GeneralSettings;